<div class="dsDialog_header">
  <h2 class="subTitle">Customize Login Background</h2>
</div>
<div class="dsDialog_content">
  <ds-branding-bg
      [isLoginPage]="isLoginPage"
      [setLoginCustomization]="loginCustomization"
      (loginBGChanged)="onLoginBGChanged($event)"
    ></ds-branding-bg>
</div>
